// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp } from 'vue/dist/vue.esm-bundler';
import App from './App'
import router from './router'
import store from './store'

// fontawesome関連
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const app = createApp(App);
library.add(faSpinner)
app.component('font-awesome-icon', FontAwesomeIcon)

app.config.productionTip = false

app.use(router);
app.use(store);
app.mount('#app');